<template>
  <div :id="`yMap-${_uid}`" class="yMap" />
</template>

<script setup lang="ts">
import ymaps from 'ymaps'
import type ymapsType from 'yandex-maps'
import {useProperty} from '~/common/ui-kit-common'
import {PropType} from 'vue';

const props = defineProps({
  coords: {
    type: Array as PropType<number[]>,
    default: () => [37.378847, 55.558741]
  },
  zoom: {
    type: Number,
    default: 10
  },
  controls: {
    type: Array as PropType<Array<string>>,
    default: []
  },
  loadCallBack: {
    type: Function as PropType<(module: typeof ymapsType, map: ymapsType.Map) => void>,
    default: () => {}
  }
})

const {_uid } = useProperty()
let yMap!: ymapsType.Map

async function initMap () {
  const maps = await ymaps
    .load('https://enterprise.api-maps.yandex.ru/2.1/?apikey=62bbf004-0f1f-4305-a219-4820afa5728d&lang=ru_RU&load=package.full')

  yMap = new maps.Map(`yMap-${_uid}`, {
    center: props.coords,
    zoom: props.zoom,
    controls: props.controls
  })

  if (props.loadCallBack) {
    props.loadCallBack(maps, yMap)
  }
}

function getMap (callBack: (map: ymapsType.Map) => void): void {
  callBack(yMap)
}

onMounted(initMap)

defineExpose({
  getMap
})
</script>

<style lang="scss">
  .yMap {
    width: 100%;
    height: 100%;
  }
</style>
